import { i18n } from '@/plugins/i18n'

export const terminalTypeList = {
    POS: 0,
    INTERNET_GATEWAY: 1,
    MOBILE_GATEWAY: 2,
    WIRELESS_POS: 3,
}

export const terminalTypeStr = {
    POS: i18n.t('pos.terminal_types.pos'),
    INTERNET_GATEWAY: i18n.t('pos.terminal_types.wireless_pos'),
    MOBILE_GATEWAY: i18n.t('pos.terminal_types.wireless_pos'),
    WIRELESS_POS: i18n.t('pos.terminal_types.wireless_pos'),

    get(terminal_type) {
        let terminal_type_str = null;
        Object.keys(terminalTypeList).forEach(function (item) {
            if(terminalTypeList[item] === terminal_type) {
                terminal_type_str = terminalTypeStr[item]
            }
        })

        return terminal_type_str
    }
}